import React from 'react';
import {
    required,
    TextInput,
    SimpleForm,
    Create,
    DateInput,
    CardActions,
    ListButton,
    Toolbar,
    EditButton,
    SaveButton,
    BooleanInput,
    ArrayInput,
    SimpleFormIterator,
    CHANGE_LOCALE_SUCCESS,
} from 'react-admin';
import {RichTextInput} from 'ra-input-rich-text';
import withStyles from '@material-ui/core/styles/withStyles';
//import TitleCheckCom from '../controls/TitleCheckCom';
import TileCom from '../controls/TitleCom'

const editStyles = {
    root: { alignItems: 'flex-start'},
    trainer_init: {  width: '2em' },
    trainee_init: {  width: '2em' },
    booth: {  width: '2em' },
    date: {
        width: '1em',
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    date_prof: {  width: '7em' },

    inlineBlock: {
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },

    td_border: {
        border: "1px solid",
        width: "25%"
    }
};

const Roles = [
    {id: '1', name: "User"},
    {id: '2', name: "Donor Processor"},
    {id: '6', name: "Plasma Processor"},
    {id: '7', name: "QA User"},
    {id: '8', name: "Site Manager"},
    {id: '9', name: "General Manager"},
    {id: '4', name: "Phlebotomy"},
    {id: '5', name: "Physician Substitute"},
    {id: '3', name: "Control Desk"},
    {id: '99', name: "Import Export"}
]


var toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons

    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    // text direction
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
                                    // remove formatting button
  ];

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CheckListCreateActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);


const CheckListCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);



const SetRecertrificateCreate = ({classes,...props }) => (
    <Create actions={<CheckListCreateActions />}   {...props} title={'Create Recertificate Setup'}>
        <SimpleForm toolbar={<CheckListCreateToolbar />} >

            <table style={{width:"99%"}} cellPadding="3">
                <tr>
                    <td>Annual Recertification Form Name:</td><td colSpan="3"><TextInput  source='name'  style={{width:"100%"}}  label=""  validate={required()}/></td>
                </tr>
                <tr>
                    <td>Employee Name:</td><td className={classes.td_border}>&nbsp;</td>
                    <td>Employee Title:</td><td className={classes.td_border}>&nbsp;</td>
                </tr>

                <tr>
                    <td colSpan="4">
                    <ArrayInput source="content" label="">
                        <SimpleFormIterator>
                            <TextInput source="procedure" label="Procedure" multiline formClassName={classes.inlineBlock} style={{width:"100%"}}/>
                            <DateInput source="date_read" label="Date of Reading" locales="en-us" formClassName={classes.date} style={{width:"8em"}}/>
                            <TextInput source="emp_init" label="employee Init" formClassName={classes.inlineBlock} style={{width:"8em"}} />
                            <DateInput source="emp_date" label="Date" locales="en-us" formClassName={classes.date} style={{width:"8em"}}/>
                        </SimpleFormIterator>
                    </ArrayInput>
                    </td>
                </tr>
                <tr>
                    <td colSpan="4"><BooleanInput   source='isphy_sub'   label="Is this for Physician Substitue?" /></td>
                </tr>
                <tr>
                    <td colSpan="4" style={{border: "1px solid"}}>
                    <table style={{width:"100%"}}>
                        <tbody>
                            <tr>
                              <td>
                                    <b>For Physician Substitue ONLY</b><br/>
                                    Physical Examination performed in presence of CMD on Date:____________<br/>
                                    <u>CMD Comments:</u><br/><br/>
                                    Center Medical Director Signature:_________________________Date:_____________
                              </td>
                            </tr>
                        </tbody>
                    </table>
                    </td>
                </tr>

                <tr>
                    <td>Exam description:</td><td colSpan="2"><TextInput  source='exam_desc'   label="" style={{width:"100%"}}/></td>
                    <td ><BooleanInput   source='yes_no' disabled   label="Pass / Fail" /></td>
                </tr>
                <tr>
                    <td>Exam Graded By: Signature:</td><td className={classes.td_border}>&nbsp;</td>
                    <td>Date:</td><td className={classes.td_border}>&nbsp;</td>
                </tr>
                <tr>
                    <td colSpan="4">
                        <table style={{width:"100%"}} cellPadding="3">
                            <tbody>
                                <tr>
                                    <td>Employee Name:</td><td className={classes.td_border} style={{width:"20%"}}>&nbsp;</td>
                                    <td>Signature:</td><td className={classes.td_border}  style={{width:"20%"}}>&nbsp;</td>
                                    <td>Date:</td><td className={classes.td_border}  style={{width:"20%"}}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>Management/ QA review:</td><td className={classes.td_border}>&nbsp;</td>
                                    <td>Signature:</td><td className={classes.td_border}>&nbsp;</td>
                                    <td>Date:</td><td className={classes.td_border}>&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td colSpan="4"><BooleanInput   source='isactive'   label="Is Active?" /></td>
                </tr>
                <tr>
                    <td >Role/ Title: </td>
                    <td colSpan="3"><TileCom props={props}  source="roles"  label = " " /></td>
                </tr>
            </table>
            </SimpleForm>

    </Create>
);

export default withStyles(editStyles)(SetRecertrificateCreate);
